import styled from "styled-components";

export const RoadmapContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  justify-content: flex-start;
  width: 100%;
  max-width: 1024px;
  margin: 20px auto;
  z-index: 0;
  margin-bottom: -125px;
  padding-bottom: 75px;
  .title-container {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: flex-end;
    justify-content: center;
    h2 {
      font-family: "Poppins";
      font-weight: 600;
      font-size: 48px;
      color: #e2d2e1;
      text-align: center;
      text-transform: uppercase;
      margin-right: 14px;
    }
    span {
      font-family: "Poppins";
      font-weight: 600;
      font-size: 32px;
      color: #e2d2e1;
      text-transform: uppercase;
    }
  }

  .tab-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border: 2px solid rgba(220, 14, 11, 0.31);
    height: 40px;
    border-radius: 20px;
    margin: 24px 0px 0px 0px;
    padding: 10px 8px;
    .circle {
      width: 24px;
      height: 24px;
      border-radius: 24px;
      background: rgba(103, 72, 82, 0.49);
      cursor: pointer;
      transition: all 1s ease;
      position: relative;
      img {
        display: none;
        position: absolute;
        top: -18px;
        left: -14px;
        width: 52px;
      }
    }
    .active-circle {
      width: 24px;
      height: 24px;
      border-radius: 24px;
      cursor: pointer;
      background: radial-gradient(circle at center, #e6a486 0, #db0000 100%);
      position: relative;
      img {
        position: absolute;
        top: -18px;
        left: -14px;
        width: 52px;
      }
    }
  }

  .text-tab-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 10px;

    .notactive {
      font-size: 12px;
      font-family: "Poppins" !important;
      font-weight: 600;
      text-align: center;
      color: #3c3e47;
    }
    .active {
      color: #e7d9e8;
      font-size: 12px;
      text-align: center;
      font-family: "Poppins" !important;
      font-weight: 600;
    }
  }

  .content-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    background: linear-gradient(rgba(103, 72, 82, 0.49) 0%, #0b090a 100%);
    width: 100%;
    max-width: 1024px;
    border-radius: 25px 25px 0px 0px;
    height: auto;
    padding: 30px;
    padding-bottom: 40px;
    margin: 24px auto;
    min-height: 320px;
    height: auto;
    h2 {
      font-size: 22px;
      line-height: 30px;
      text-align: left;
      color: #e7d9e8;
      font-family: "Poppins";
      font-weight: 600;
      margin-bottom: 18px;
    }
    span {
      font-size: 18px;
      text-align: left;
      color: #e7d9e8;
      font-family: "Poppins";
      font-weight: 300;
    }
  }
`;
